
import devops_cert from '../../assets/img/gallery/devops_cert.jpg';
import agile from '../../assets/img/gallery/agile.jpg';

export default [
  {
    designation: 'DevOps Essentials',
    cert: devops_cert,
    size: '450rem'
  },
  {
    designation: 'Agile Scrum',
    cert: agile,
    size: '450rem'
  },
];
